import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BadgeComponent } from './badge.component';

@NgModule({
  declarations: [BadgeComponent, BadgeComponent],
  exports: [BadgeComponent, BadgeComponent],
  imports: [CommonModule],
})
export class BadgeModule {}
